<template>
  <div>
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.message_1">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ FirstMessageMixin() }}<br />
              本サービスは19歳〜29歳の方ならどなたでもご利用いただけます。<br />
              スムーズに<span class="txt-under">最適な求人をご紹介するために、{{ displayTotalFormContentsCount(formCount.total) }}だけ、あなたについておしえてください！</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import functionsMixin from '../../mixins/functionsMixin'
import FirstMessageMixin from '../../mixins/FirstMessageMixin'
import WritingAnimation from '../animations/WritingAnimation'

export default {
  name: 'FirstMessage',
  mixins: [functionsMixin, FirstMessageMixin],
  components: {
    WritingAnimation
  },
  props: {
    formCount: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      show: {
        writing_1: true,
        message_1: false,
        writing_2: false,
        message_2: false
      }
    }
  },
  mounted: function () {
    setTimeout(function () {
      this.show.writing_1 = false
      this.show.message_1 = true
      this.autoScroll()
      this.endFirstMessage()
    }.bind(this), 2000)
    this.FirstMessageMixin()
  },
  methods: {
    displayTotalFormContentsCount: function (total) {
      if (Number(total) < 10) {
        return `${total}つ`
      }
      return `${total}問`
    },
    endFirstMessage: function () {
      this.$emit('end-first-message')
    }
  }
}
</script>

<style lang="scss" scoped>
.fade {
  &-enter-active, &-leave-active {
    will-change: opacity;
    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FirstMessage.vue